<div class="spinner-container" *ngIf="isLoading">
    <app-spinner></app-spinner>
</div>


<div *ngIf="!isLoading">
    <div class="container">
        <div class="row flex-row">
            <div *ngIf="!isTypeFiltered" class="wrapper-searchsort">
                <div class="input-group mt-4">
                    <input
                        class="search-input"
                        type="text"
                        (keyup)="search(searchText)" [(ngModel)]="searchText"
                        aria-describedby="basic-addon1"
                        placeholder="{{ translateLabel('Search', 'Search') | async }}"
                        maxlength="64"/>
                        <span id="basic-addon1">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
        <path stroke="#004D9F"
              d="M10.3636 3C8.90722 3 7.48354 3.43187 6.2726 4.24099C5.06167 5.05011 4.11786 6.20015 3.56052 7.54567C3.00319 8.89119 2.85737 10.3718 3.14149 11.8002C3.42562 13.2286 4.12693 14.5406 5.15675 15.5704C6.18657 16.6003 7.49863 17.3016 8.92703 17.5857C10.3554 17.8698 11.836 17.724 13.1815 17.1667C14.527 16.6093 15.6771 15.6655 16.4862 14.4546C17.2953 13.2437 17.7272 11.82 17.7272 10.3636C17.7271 8.41069 16.9512 6.5378 15.5703 5.15688C14.1894 3.77597 12.3165 3.00012 10.3636 3V3Z"
              stroke-width="2" stroke-miterlimit="10"/>
        <path fill="#004D9F"
              d="M16.5645 15.1503C16.174 14.7598 15.5408 14.7598 15.1503 15.1503C14.7598 15.5408 14.7598 16.174 15.1503 16.5645L16.5645 15.1503ZM15.1503 16.5645L20.293 21.7072L21.7072 20.293L16.5645 15.1503L15.1503 16.5645Z"/>
    </svg>
                        </span>
                </div>
                <div class="navbar mt-4">
                <div class="dropdown show">
                    <a class="chevron" href="#" role="button"
                       id="dropdownManual"
                       data-toggle="dropdown"
                       aria-haspopup="true"
                       aria-expanded="false"
                            [appTranslate]="'SortBy'">Sort by
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownManual">
                        <a class="dropdown-item" (click)="orderEvents('name-asc')" [appTranslate]="'AZ'">A-Z</a>
                        <a class="dropdown-item" (click)="orderEvents('name-desc')" [appTranslate]="'ZA'">Z-A</a>
                        <a class="dropdown-item" (click)="orderEvents('date-desc')" [appTranslate]="'Newest'">Newest
                        </a>
                        <a class="dropdown-item" (click)="orderEvents('date-asc')" [appTranslate]="'Oldest'">Oldest
                        </a>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="error">
        <app-errormessage
            [serverErrorMessage]="error.message"
            [errorMessageTranslationKey]="error.localizationKey">
        </app-errormessage>
    </div>

    <div *ngIf="allEvents && allEvents.length" class="container" id="all-events">
        <div class="row cards-container cards-container--3-cols">
            <a class="card card--white card--col-1"
               *ngFor="let event of filteredEvents"
               [routerLink]="hasExternalLink(event) ? ['/externalRedirect'] : ['/event']"
               [queryParams]="hasExternalLink(event) ? { externalUrl: event.publicEventUrl} : {id: event.readableEventId}">
                <div class="card__image" [style.background-image]="'url(' + getBannerImage(event) + ')'">
                </div>
                <div class="card__body">
                    <p class="card__tag">{{ event.building?.name || ' ' }}</p>
                    <p class="card__date">{{ this.labelsService.getDateString(event) }}</p>
                    <div title="{{ event.eventName }}" [attr.aria-label]="getAreaLabel(event)">
                        <h4 class="card__title">{{ event.eventName }}</h4>
                    </div>
                    <p *ngIf="event.customFields && event.customFields.new_short_description" class="card__text">
                        {{event.customFields.new_short_description}}
                    </p>
                    <br/>
                </div>
            </a>
        </div>
    </div>
    <section *ngIf="allEvents && !allEvents.length" class="section section--bg-light c-text">
        <div class="section__container">
            <div class="c-text__wrapper text-center">
                <div class="c-text__content">
                    <p [appTranslate]="'NoEvents'">No Events</p>
                </div>
            </div>
        </div>
    </section>
</div>
